import React from 'react';
import Modal from 'react-modal';
import ImageGallery from 'react-image-gallery';
import style from './ImageGalleryModal.module.less';
import x from './assets/x.png';

interface ImageGalleryModalProps {
  isOpen: boolean;
  onClose: () => void;
  images: any[];
  startIndex: number;
}

export const ImageGalleryModal: React.FC<ImageGalleryModalProps> = (props) => {
  const renderLeftNav = (onClick, disabled) => (
    <button
      className="custom-left-nav"
      onClick={onClick}
      disabled={disabled}
      style={{
        position: "absolute",
        top: "50%",
        left: "10px",
        transform: "translateY(-50%)",
        background: "none",
        border: "none",
        cursor: "pointer",
        zIndex: 1,
      }}
    >
      <img
        src={props.images[0].original}
        alt="Left"
        style={{ width: "30px", height: "30px" }}
      />
    </button>
  );
  
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={() => props.onClose()}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1005
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: '0',
          border: 'none',
          borderRadius: '0'
        }
      }}
      contentLabel="Newsletter Modal"
    >
      <div className={style.modalContent}>
        <div className={style.wrapper}>
          <button className={style.close} type="button" onClick={() => props.onClose()}>
            <img src={x} alt="close" />
          </button>
          <ImageGallery
            startIndex={props.startIndex}
            additionalClass={style.gallery}
            items={props.images}
            showNav={true}
            showThumbnails={false}
            showFullscreenButton={true}
            showPlayButton={false}
            showBullets={false}
            // renderLeftNav={renderLeftNav}
          />
        </div>
      </div>
    </Modal>
  );
};
